export default __webpack_public_path__ + "static/media/19_SunTige.8064fef9.png";